"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildDateRangeInfo = buildDateRangeInfo;
exports.buildDateRangeOptionByKey = buildDateRangeOptionByKey;
exports.default = void 0;
exports.findSeparator = findSeparator;
exports.styles = void 0;
exports.yearAndMonth = yearAndMonth;
exports.yearAndQuarter = yearAndQuarter;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));
var _react = _interopRequireDefault(require("react"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _reactDom = require("react-dom");
var _withStyles = _interopRequireDefault(require("@mui/styles/withStyles"));
var _HiSelectField = _interopRequireDefault(require("../HiSelect/HiSelectField"));
var _HiDateRangePicker = _interopRequireDefault(require("./HiDateRangePicker"));
var _HiFormControl = _interopRequireDefault(require("../HiForm/HiFormControl"));
var _reactDeviceDetect = require("react-device-detect");
var _Calendar = _interopRequireDefault(require("mdi-material-ui/Calendar"));
var _CalendarBlank = _interopRequireDefault(require("mdi-material-ui/CalendarBlank"));
var _CalendarArrowRight = _interopRequireDefault(require("mdi-material-ui/CalendarArrowRight"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function findSeparator(format) {
  var str = '';
  if (format.search('[/]') >= 0) {
    str = '/';
  } else if (format.search('[-]') >= 0) {
    str = '-';
  } else if (format.search('[.]') >= 0) {
    str = '.';
  }
  return str;
}
function yearAndMonth(format, date) {
  var findY = function findY(el) {
    return el.toUpperCase().search('Y') >= 0;
  };
  var findM = function findM(el) {
    return el.toUpperCase().search('M') >= 0;
  };
  var s = findSeparator(format);
  var split = format.split(s);
  var indexY = split.findIndex(findY);
  var indexM = split.findIndex(findM);
  return indexY < indexM ? date.format(split[indexY] + s + split[indexM]) : date.format(split[indexM] + s + split[indexY]);
}
function yearAndQuarter(format, date, t) {
  var findY = function findY(el) {
    return el.toUpperCase().search('Y') >= 0;
  };
  var findM = function findM(el) {
    return el.toUpperCase().search('M') >= 0;
  };
  var s = findSeparator(format);
  var split = format.split(s);
  var indexY = split.findIndex(findY);
  var indexM = split.findIndex(findM);
  return indexY < indexM ? date.format("".concat(split[indexY]).concat(s, "[").concat(t.short_quarter, "]Q")) : date.format("[".concat(t.short_quarter, "]Q").concat(s).concat(split[indexY]));
}
function buildDateRangeInfo(t, from, to, format) {
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var _options$prefix = options.prefix,
    prefix = _options$prefix === void 0 ? null : _options$prefix,
    _options$toNow = options.toNow,
    toNow = _options$toNow === void 0 ? false : _options$toNow,
    _options$toToday = options.toToday,
    toToday = _options$toToday === void 0 ? false : _options$toToday,
    _options$displayDays = options.displayDays,
    displayDays = _options$displayDays === void 0 ? true : _options$displayDays,
    _options$displayDayNa = options.displayDayName,
    displayDayName = _options$displayDayNa === void 0 ? false : _options$displayDayNa; // From
  var info = "".concat(t.from, " ").concat(from.format(format), " ");

  // Display day name
  if (displayDayName) {
    info = "".concat(t.from, " ").concat(from.format('dddd'), "  ").concat(from.format(format), " ");
  }

  // To
  if (toToday) {
    info += "".concat(t.to_today);
  } else if (toNow) {
    info += "".concat(t.to_now);
  } else {
    info += "".concat(t.to, " ").concat(to.format(format));
  }

  // Prefix
  switch (prefix) {
    case 'week':
      info = "".concat(t.short_week).concat(from.format('w'), ", ").concat(info);
      break;
    case 'quarter':
      info = "".concat(t.short_quarter).concat(from.format('Q'), ", ").concat(info);
      break;
    default:
      break;
  }

  // Display number of days
  if (displayDays) {
    var days = Math.ceil(to.diff(from, 'days', true));
    info = "".concat(days, " ").concat(days === 1 ? t.day : t.days, ", ").concat(info);
  }
  return info;
}
function buildDateRangeOptionByKey(key, t, format) {
  var from;
  var label;
  var info;
  var to;
  var days;
  switch (key) {
    case 'custom':
      label = t.custom_period;
      from = (0, _momentTimezone.default)().subtract(15, 'day').startOf('day');
      to = (0, _momentTimezone.default)().endOf('day');
      info = t.custom_period_info;
      break;
    case 'cd':
      label = t.today;
      from = (0, _momentTimezone.default)().startOf('day');
      to = (0, _momentTimezone.default)();
      info = "".concat(from.format(format));
      break;
    case 'pd':
      label = t.yesterday;
      from = (0, _momentTimezone.default)().subtract(1, 'day').startOf('day');
      to = (0, _momentTimezone.default)().subtract(1, 'day').endOf('day');
      info = "".concat(from.format(format));
      break;
    case 'cw':
      label = t.current_week;
      from = (0, _momentTimezone.default)().startOf('week');
      to = (0, _momentTimezone.default)();
      info = buildDateRangeInfo(t, from, to, format, {
        prefix: 'week',
        toNow: true,
        displayDays: true
      });
      break;
    case 'pw':
      label = t.previous_week;
      from = (0, _momentTimezone.default)().subtract(1, 'week').startOf('week');
      to = (0, _momentTimezone.default)().subtract(1, 'week').endOf('week');
      info = buildDateRangeInfo(t, from, to, format, {
        prefix: 'week',
        toNow: false,
        displayDays: true
      });
      break;
    case 'cm':
      label = t.current_month;
      from = (0, _momentTimezone.default)().startOf('month');
      to = (0, _momentTimezone.default)();
      info = buildDateRangeInfo(t, from, to, format, {
        prefix: null,
        toNow: true,
        displayDays: true
      });
      break;
    case 'pm':
      label = t.previous_month;
      from = (0, _momentTimezone.default)().subtract(1, 'month').startOf('month');
      to = (0, _momentTimezone.default)().subtract(1, 'month').endOf('month');
      days = from.daysInMonth();
      info = "".concat(days, " ").concat(days === 1 ? t.day : t.days, ", ").concat(yearAndMonth(format, from));
      break;
    case 'cq':
      label = t.current_quarter;
      from = (0, _momentTimezone.default)().startOf('quarter');
      to = (0, _momentTimezone.default)();
      info = buildDateRangeInfo(t, from, to, format, {
        prefix: 'quarter',
        toNow: true,
        displayDays: true
      });
      break;
    case 'pq':
      label = t.previous_quarter;
      from = (0, _momentTimezone.default)().subtract(1, 'quarter').startOf('quarter');
      to = (0, _momentTimezone.default)().subtract(1, 'quarter').endOf('quarter');
      info = buildDateRangeInfo(t, from, to, format, {
        prefix: 'quarter',
        toNow: false,
        displayDays: true
      });
      break;
    case 'cy':
      label = t.current_year;
      from = (0, _momentTimezone.default)().startOf('year');
      to = (0, _momentTimezone.default)();
      info = buildDateRangeInfo(t, from, to, format, {
        prefix: null,
        toNow: true,
        displayDays: true
      });
      break;
    case '1':
      label = '24h';
      from = (0, _momentTimezone.default)().subtract(1, 'day');
      to = (0, _momentTimezone.default)();
      info = "".concat(t.from, " ").concat(from.format('HH:mm'), " ").concat(t.yesterday.toLowerCase(), " ").concat(t.to_now);
      break;
    default:
      if (parseInt(key) > 0) {
        label = "".concat(key, " ").concat(key === 1 ? t.day : t.days);
        from = (0, _momentTimezone.default)().subtract(parseInt(key), 'day');
        to = (0, _momentTimezone.default)();
        info = buildDateRangeInfo(t, from, to, format, {
          prefix: null,
          toNow: true,
          toToday: key === 1,
          displayDays: false,
          displayDayName: true
        });
      }
      break;
  }
  return {
    id: key,
    from: from,
    info: info,
    label: label,
    to: to
  };
}
var styles = exports.styles = function styles(theme) {
  return {
    root: {
      maxWidth: 500,
      alignItems: 'flex-start',
      display: 'flex',
      '@media(max-width: 700px)': {
        flexDirection: 'column'
      }
    },
    dateRangePicker: {
      width: '100%',
      marginTop: 0
    },
    smSelect: {
      padding: theme.spacing(1)
    },
    smRangePicker: {},
    select: {
      '@media(max-width: 700px)': {
        width: '100%',
        paddingBottom: theme.spacing(2)
      },
      '@media(min-width: 700px)': {
        minWidth: 200,
        width: 'calc(100% - 244px)',
        marginRight: theme.spacing(2)
      }
    },
    input: {
      '@media(max-width: 700px)': {
        width: '100%'
      },
      '@media(min-width: 700px)': {
        width: 236
      }
    },
    formControlLabel: {
      top: theme.spacing(5),
      overflow: 'unset'
    }
  };
};
var PRESET_PERIOD_LIST = ['cd', 'pd', 'cw', 'pw', 'cm', 'pm', 'cq', 'pq', 'cy'];
var SLIDING_PERIOD_LIST = ['1', '7', '30', '365'];
var CUSTOM_PERIOD_LIST = ['custom'];
var _ref2 = /*#__PURE__*/_react.default.createElement(_CalendarBlank.default, null);
var _ref3 = /*#__PURE__*/_react.default.createElement(_Calendar.default, null);
var _ref4 = /*#__PURE__*/_react.default.createElement(_CalendarArrowRight.default, null);
var HiDateRangeSelector = /*#__PURE__*/function (_React$Component) {
  function HiDateRangeSelector(props) {
    var _this;
    (0, _classCallCheck2.default)(this, HiDateRangeSelector);
    _this = _callSuper(this, HiDateRangeSelector, [props]);
    _this.options = [];
    _this.handleBlur = function (event) {
      if (event instanceof Object && _this.props.onblur) {
        _this.props.onBlur(event);
      }
    };
    _this.handleReset = function (name) {
      _this.props.onChange(name, undefined);
      _this.props.onChange("".concat(name, "Error"), undefined);
    };
    _this.handleSelectChange = function (name) {
      return function (event, value) {
        _this.setState(function (prevState) {
          return (0, _defineProperty2.default)((0, _defineProperty2.default)({}, name, value), "key", prevState.key === 1 ? 2 : 1);
        });
        _this.updateDates(value);
      };
    };
    _this.options = props.availableOptionKeys.map(function (key) {
      return buildDateRangeOptionByKey(key, props.translations, props.format);
    });
    _this.state = {
      selectedPreset: props.defaultPreset,
      containerWidth: 0
    };
    return _this;
  }
  (0, _inherits2.default)(HiDateRangeSelector, _React$Component);
  return (0, _createClass2.default)(HiDateRangeSelector, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.container) {
        this.setState({
          containerWidth: (0, _reactDom.findDOMNode)(this.container).clientWidth - 5
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timeout); // TODO : supprimer ?
    }
  }, {
    key: "updateDates",
    value: function updateDates(value) {
      var selectedOption = this.options.find(function (option) {
        return option.id === value;
      });
      if (selectedOption) {
        this.props.onChange('from', selectedOption.from.toDate());
        this.props.onChange('to', selectedOption.to.toDate());
        this.props.onChange('fromError', false);
        this.props.onChange('toError', false);
      }
      if (this.props.returnSelectValue === true) {
        this.props.onChange('period', value);
      }
    }
  }, {
    key: "buildOptions",
    value: function buildOptions() {
      var _this$props = this.props,
        availableOptionKeys = _this$props.availableOptionKeys,
        translations = _this$props.translations;
      var selectedPreset = this.state.selectedPreset;
      var options = [];
      var presetOptionsAvailable = availableOptionKeys.filter(function (option) {
        return PRESET_PERIOD_LIST.includes(option);
      });
      var slidingOptionsAvailable = availableOptionKeys.filter(function (option) {
        return SLIDING_PERIOD_LIST.includes(option);
      });
      var customOptionsAvailable = availableOptionKeys.filter(function (option) {
        return CUSTOM_PERIOD_LIST.includes(option);
      });
      if (customOptionsAvailable.length) {
        options.push({
          id: 'custom_periods_subheader',
          type: CUSTOM_PERIOD_LIST.includes(selectedPreset) ? 'primary-highlight' : 'highlight',
          icon: _ref2,
          label: translations.custom_periods,
          children: this.options.filter(function (o) {
            return customOptionsAvailable.includes(o.id);
          }),
          collapseParent: true
        });
      }
      if (presetOptionsAvailable.length) {
        options.push({
          id: 'preset_periods_subheader',
          type: PRESET_PERIOD_LIST.includes(selectedPreset) ? 'primary-highlight' : 'highlight',
          icon: _ref3,
          label: translations.preset_periods,
          children: this.options.filter(function (o) {
            return presetOptionsAvailable.includes(o.id);
          }),
          collapseParent: true
        });
      }
      if (slidingOptionsAvailable.length) {
        options.push({
          id: 'sliding_periods_subheader',
          type: SLIDING_PERIOD_LIST.includes(selectedPreset) ? 'primary-highlight' : 'highlight',
          icon: _ref4,
          label: translations.sliding_periods,
          children: this.options.filter(function (o) {
            return slidingOptionsAvailable.includes(o.id);
          }),
          collapseParent: true
        });
      }
      return options;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        availableOptionKeys = _this$props2.availableOptionKeys,
        disabled = _this$props2.disabled,
        enableTime = _this$props2.enableTime,
        errorText = _this$props2.errorText,
        fromError = _this$props2.fromError,
        toError = _this$props2.toError,
        helperIcon = _this$props2.helperIcon,
        helperText = _this$props2.helperText,
        idRange = _this$props2.idRange,
        idSelect = _this$props2.idSelect,
        minimumDate = _this$props2.minimumDate,
        disableFutureDays = _this$props2.disableFutureDays,
        label = _this$props2.label,
        from = _this$props2.from,
        onChange = _this$props2.onChange,
        required = _this$props2.required,
        to = _this$props2.to,
        translations = _this$props2.translations,
        classes = _this$props2.classes,
        selectProps = _this$props2.selectProps,
        staticPosition = _this$props2.staticPosition,
        className = _this$props2.className,
        props = (0, _objectWithoutProperties2.default)(_this$props2, ["availableOptionKeys", "disabled", "enableTime", "errorText", "fromError", "toError", "helperIcon", "helperText", "idRange", "idSelect", "minimumDate", "disableFutureDays", "label", "from", "onChange", "required", "to", "translations", "classes", "selectProps", "staticPosition", "className"]);
      var _this$state = this.state,
        selectedPreset = _this$state.selectedPreset,
        containerWidth = _this$state.containerWidth;
      var hiSelectableListProps = {
        secondaryInline: false,
        hideCheckbox: true,
        lazy: false,
        collapseParent: true,
        noPadding: true
      };
      var options = this.buildOptions();
      return /*#__PURE__*/_react.default.createElement(_HiFormControl.default, {
        disabled: disabled,
        helperIcon: helperIcon,
        helperText: helperText,
        errorText: errorText,
        error: !!(fromError || toError),
        label: ' ',
        className: className,
        InputLabelProps: {
          className: classes.formControlLabel
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: classes.root,
        style: containerWidth < 364 ? {
          flexDirection: 'column'
        } : {},
        ref: function ref(container) {
          _this2.container = container;
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: classes.select,
        style: containerWidth < 364 ? {
          minWidth: '100%',
          paddingBottom: 8,
          paddingRight: 0
        } : {}
      }, /*#__PURE__*/_react.default.createElement(_HiSelectField.default, (0, _extends2.default)({
        disabled: disabled,
        id: idSelect,
        label: label,
        hideCheckbox: true,
        hiSelectableListProps: hiSelectableListProps,
        name: 'selectedPreset',
        options: options,
        onChange: this.handleSelectChange('selectedPreset'),
        required: required,
        translations: translations,
        value: selectedPreset,
        containerWidth: this.state.containerWidth,
        staticPosition: staticPosition,
        onSubmit: this.props.onSubmit
      }, selectProps))), (_reactDeviceDetect.isMobile && selectedPreset === 'custom' || !_reactDeviceDetect.isMobile) && /*#__PURE__*/_react.default.createElement("div", {
        className: classes.input,
        style: containerWidth < 364 ? {
          width: '100%'
        } : {}
      }, /*#__PURE__*/_react.default.createElement(_HiDateRangePicker.default, (0, _extends2.default)({
        key: this.state.key,
        classes: {
          root: classes.dateRangePicker
        },
        id: idRange,
        from: selectedPreset ? from : undefined,
        to: selectedPreset ? to : undefined,
        enableTime: enableTime,
        onChange: onChange,
        toError: toError,
        fromError: fromError,
        disableFutureDays: disableFutureDays,
        minimumDate: minimumDate,
        errorText: null,
        onReset: this.handleReset,
        disabled: disabled || selectedPreset !== 'custom',
        translations: translations,
        staticPosition: staticPosition,
        onBlur: this.handleBlur,
        hasSelector: true
      }, props)))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props) {
      if (props.returnSelectValue) {
        return {
          selectedPreset: props.defaultPreset
        };
      }
      return null;
    }
  }]);
}(_react.default.Component);
HiDateRangeSelector.defaultProps = {
  availableOptionKeys: [].concat(PRESET_PERIOD_LIST, CUSTOM_PERIOD_LIST),
  disableFutureDays: true,
  enableTime: false,
  returnSelectValue: false,
  staticPosition: false,
  locale: 'fr-FR',
  format: 'YYYY-DD-MM',
  minimumDate: new Date(2013, 4, 1),
  // by default 1 May 2013
  translations: {
    today: 'Today',
    hour: 'Hour',
    minute: 'Minute',
    month: 'Month',
    quarter: 'Quarter',
    week: 'Week',
    short_week: 'W',
    short_quarter: 'Q',
    yearAndMonth: 'YYYY[-]MM',
    yearAndQuarter: 'YYYY[-Q]Q',
    year: 'Year',
    day: 'day',
    days: 'days',
    custom_period: 'Custom Period',
    yesterday: 'Yesterday',
    from: 'from',
    to: 'to',
    to_now: 'to now',
    to_today: 'to today',
    current_week: 'Current Week',
    previous_week: 'Previous Week',
    current_month: 'Current Month',
    previous_month: 'Previous Month',
    current_quarter: 'Current Quarter',
    previous_quarter: 'Previous Quarter',
    current_year: 'Current Year',
    year_on_year: 'Last twelve months',
    invalid_format: 'The date format is not valid',
    to_superior_from: 'Date from cannot be greater than date to',
    date_superior_max_date: 'Date from cannot be greater than %s',
    date_inferior_min_date: 'Date from cannot be before than %s',
    missing_date_from: 'Missing date from',
    missing_date_to: 'Missing date to',
    preset_periods: 'Preset periods',
    custom_periods: 'Custom periods',
    custom_period_info: 'Select a custom period',
    sliding_periods: 'Sliding periods'
  }
};
var _default = exports.default = (0, _withStyles.default)(styles, {
  name: 'HmuiHiDateRangeSelector'
})(HiDateRangeSelector);